module.exports = __webpack_public_path__ + "img/mkr.3f8c8bd4.svg";